<template>
  <div class="mc-request-detail">
    <PageHeader class="mc-request-detail__page-header" :title="title">
      <template #afterTitle>
        <ActionButtons :status="status" :showResponse="showResponse" />
      </template>
    </PageHeader>
    <BasicInfoDetail :showResponse="showResponse" />
    <div>
      <div class="d-flex mc-list-header mt-3 mb-2 align-items-center">
        <h4 class="card-title flex-grow-1">
          {{ $t('fleetTask.orderTask') }}
        </h4>
      </div>

      <b-card>
        <b-row class="g-0 mb-3 mc-total">
          <b-col sm="12" md="2">
            <div>{{ $t('fleetTask.fields.totalWeight') }}</div>
            <div v-if="!isLoading" class="fw-bold">{{ totalLoadWeight }} Kg</div>
            <div v-else>...</div>
          </b-col>

          <b-col sm="12" md="2">
            <div>{{ $t('fleetTask.fields.totalVolume') }}</div>
            <div v-if="!isLoading" class="fw-bold">{{ totalLoadVolume }} Cbm</div>
            <div v-else>...</div>
          </b-col>
        </b-row>

        <Sequence
          :sequence="sequence"
          :missedRequiredFields="missedSequencingRequiredFields"
          :isLoading="isLoading"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import appConfig from '@/app.config'
import { computed } from 'vue'

import PageHeader from '@/components/page-header-v2'
import ActionButtons from '../components/fleet-task/ActionButtons'
import Sequence from '../components/fleet-task/Sequence'
import BasicInfoDetail from '../components/fleet-task/BasicInfoDetail'
import * as Request from '@/services/rest-api/lib/request/fleet-task'

export default {
  page: {
    title: 'Fleet Task Request',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    ActionButtons,
    BasicInfoDetail,
    Sequence,
  },
  provide() {
    return {
      isLoading: computed(() => this.isLoading),
      companyName: computed(() => this.companyName),
      totalLoadWeight: computed(() => this.totalLoadWeight),
      totalLoadVolume: computed(() => this.totalLoadVolume),
    }
  },
  data() {
    return {
      isLoading: false,
      showResponse: {},
      sequence: [],
      missedSequencingRequiredFields: [],
      status: '',
    }
  },
  computed: {
    title() {
      return this.$t('deliveryRequest.detail.fleetTaskTitle', { number: this.deliveryNumber })
    },
    deliveryNumber() {
      return this.showResponse?.parent_number || ''
    },
    totalLoadWeight() {
      return this.showResponse?.parent_total_weight || 0
    },
    totalLoadVolume() {
      return this.showResponse?.parent_total_volume || 0
    },
    companyName() {
      return this.showResponse?.parent_company?.name || ''
    },
  },
  async mounted() {
    this.isLoading = true
    const res = await Request.show(this.$route.params.id)

    if (res.errors) {
      this.$mcToast.error(this.$t('delivery.alert.requestError'))
      return
    }

    this.showResponse = res.data
    this.sequence = res?.data.parent_point_activity_list
    if (this.sequence) {
      const hasStart = this.sequence.some((item) =>
        item.activities.some((activity) => activity.type === 'START')
      )

      const hasEnd = this.sequence.some((item) =>
        item.activities.some((activity) => activity.type === 'END')
      )

      if (!hasStart) {
        this.sequence.unshift({
          activities: [
            {
              type: 'START',
            },
          ],
        })
      }

      if (!hasEnd) {
        this.sequence.push({
          activities: [
            {
              type: 'END',
            },
          ],
        })
      }
    }

    this.status = res?.data?.status?.name
    this.isLoading = false
  },
}
</script>

<style lang="scss" scoped>
.mc-request-detail {
  &__page-header {
    margin-bottom: 40px !important;
  }
}
</style>
